// Single source of truth for service names, emojis, and URL slugs.
// IMPORTANT: keys correspond to existing DB enum `service_type` values,
// EXCEPT `sesion_fotos` which is a "virtual" service — only used as a
// search filter (cuidadores cannot offer it).

export const serviceLabels: Record<string, string> = {
  hospedaje_noche: "Hospedaje",
  visita_domicilio: "Cuidado en casa",
  paseo_1hr: "Visitas en casa",
  daycare: "Day Care (8h)",
  paseo_30min: "Paseos (1h)",
  entrenamiento: "Sesión de Ejercicio (1h)",
  sesion_fotos: "Sesión de Fotos",
  transporte: "Ride de Mascotas",
};

export const serviceEmojis: Record<string, string> = {
  hospedaje_noche: "🧳",
  visita_domicilio: "🏡",
  paseo_1hr: "📍",
  daycare: "🧸",
  paseo_30min: "🦮",
  entrenamiento: "🏃🏻‍♀️",
  sesion_fotos: "📸",
  transporte: "🚗",
};

// URL slug ↔ service key mapping for /servicios/<slug> routes
export const serviceSlugToKey: Record<string, string> = {
  hospedaje: "hospedaje_noche",
  "cuidado-en-casa": "visita_domicilio",
  "visitas-en-casa": "paseo_1hr",
  "day-care": "daycare",
  paseos: "paseo_30min",
  "sesion-de-ejercicio": "entrenamiento",
  "sesion-de-fotos": "sesion_fotos",
};

export const serviceKeyToSlug: Record<string, string> = Object.fromEntries(
  Object.entries(serviceSlugToKey).map(([slug, key]) => [key, slug])
);

// Ordered list of the 7 official services for Hero / Features / /buscar dropdowns.
// Excludes `transporte` (kept invisible in public filters per business rules).
export const serviceFilterOptions: { value: string; label: string; emoji: string; slug: string }[] = [
  { value: "hospedaje_noche", slug: "hospedaje" },
  { value: "visita_domicilio", slug: "cuidado-en-casa" },
  { value: "paseo_1hr", slug: "visitas-en-casa" },
  { value: "daycare", slug: "day-care" },
  { value: "paseo_30min", slug: "paseos" },
  { value: "entrenamiento", slug: "sesion-de-ejercicio" }
].map((s) => ({ ...s, label: serviceLabels[s.value], emoji: serviceEmojis[s.value] }));

// Services that caregivers CAN offer (excludes `sesion_fotos`, includes `transporte`).
export const caregiverAssignableServices: string[] = [
  "hospedaje_noche",
  "visita_domicilio",
  "paseo_1hr",
  "daycare",
  "paseo_30min",
  "entrenamiento",
  "transporte",
];

// Backwards compatibility — kept for files that still import allServiceTypes
export const allServiceTypes = caregiverAssignableServices;
